export default [
  { value: undefined, label: '' },
  { value: 'aggregator', label: 'Aggregator' },
  { value: 'sushi', label: 'Sushi' }
];
